import { ReactNode } from "react";

import {
    Design,
    DesignHovered,
    Finance,
    FinanceHovered,
    Hr,
    HrHovered,
    Marketing,
    MarketingHovered,
    ProductManagement,
    ProductManagementHovered,
    ProjectManagement,
    ProjectManagementHovered,
    Recommended,
    RecommendedHovered,
    Software,
    SoftwareHovered
} from "@/components/confluence/icons";
import { CategoryKey } from "@/templates/software/confluence/templates/confluence-templates-page/src/config/category-template-order.ts";

export interface IconPair {
    icon: ReactNode;
    iconHovered: ReactNode;
}

export function getIcons(key: CategoryKey): IconPair {
    switch (key) {
        case "recommended":
            return {
                icon: <Recommended />,
                iconHovered: <RecommendedHovered />
            };

        case "project-management":
            return {
                icon: <ProjectManagement />,
                iconHovered: <ProjectManagementHovered />
            };

        case "software-development-and-it":
            return {
                icon: <Software />,
                iconHovered: <SoftwareHovered />
            };

        case "product-management":
            return {
                icon: <ProductManagement />,
                iconHovered: <ProductManagementHovered />
            };

        case "marketing-and-sales":
            return {
                icon: <Marketing />,
                iconHovered: <MarketingHovered />
            };

        case "design":
            return {
                icon: <Design />,
                iconHovered: <DesignHovered />
            };

        case "finance-and-operations":
            return {
                icon: <Finance />,
                iconHovered: <FinanceHovered />
            };

        case "human-resources":
            return {
                icon: <Hr />,
                iconHovered: <HrHovered />
            };

        default:
            return {
                icon: <Design />,
                iconHovered: <DesignHovered />
            } as never;
    }
}
